import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { track } from "../lib/analytics";

/**
 * AnalyticsTracker — mounts once inside the Router.
 *  - Fires a page_view on every route change.
 *  - Delegated click tracking: any element with [data-track], plus
 *    mailto: and tel: links, reported as cta_click events.
 */
export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  const last = useRef({ path: null, at: 0 });

  useEffect(() => {
    if (pathname.startsWith("/admin")) return; // internal tool, not site traffic
    // Guard against double-fires (StrictMode / rapid re-renders).
    const now = Date.now();
    if (last.current.path === pathname && now - last.current.at < 1500) return;
    last.current = { path: pathname, at: now };
    track("page_view", pathname);
  }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest("[data-track], a[href^='mailto:'], a[href^='tel:']");
      if (!el) return;
      const href = el.getAttribute("href") || "";
      const label =
        el.getAttribute("data-track") ||
        (href.startsWith("mailto:") ? "email-click" : href.startsWith("tel:") ? "phone-click" : "");
      if (label) track("cta_click", window.location.pathname, label);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return null;
}
